import React from "react";
import { Box, Grid, Button, Typography } from "@mui/material";
import {
  getCardBrand,
  getCardExpiry,
  getMaskedCardNumber,
} from "helpers/creditCard";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { StoredCardResult } from "../../Reservation/steps/Payment/paymentType";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { AppState } from "components/store/reducers/rootReducer";

import { useTranslation } from "react-i18next";
import StoredPaymentResult from "./storedPaymentResult";

const SavedCardResult: React.FC<StoredCardResult> = (props) => {
  const theme = useTheme();
  const IsDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const { t } = useTranslation();
const { companyInfo } = useSelector((state: AppState) => state.companyInfo);

  return (
    <Box
      boxShadow={3}
      p={3}
      bgcolor="background.paper"
      style={{
        textAlign: "center",
        marginLeft: IsDesktop ? "30%" : "0%",
        width: IsDesktop ? "40%" : "100%",
        verticalAlign: "middle",
        justifyContent: "center",
      }}
    >
      {props.errors.length > 0 && (
        <Typography
          id="lblErrorMessage"
          variant="body2"
          style={{ textAlign: "left", color: "#DF0000", marginBottom: "10px" }}
        >
          {" "}
          {props.errors}{" "}
        </Typography>
      )}
      {props.isExpired && (
        <Typography
          id="expiredCardMessage"
          sx={{
            textAlign: "left",
            marginBottom: "0.8rem",
            color: "error.main",
          }}
        >
          {t("ExpiredCardAlert")}
        </Typography>
      )}
      <StoredPaymentResult
        cardNumber={getMaskedCardNumber(
          props.data?.cardDetails.maskedCardNumber
        )}
        cardExpiry={getCardExpiry(
          props.data?.cardDetails.expiration.lastValidMonth.toString(),
          props.data?.cardDetails.expiration.year.toString()
        )}
        cardBrand={getCardBrand(
          props.data?.cardAttributes.cardBrand.toString()
        )}
        savedPayment={true}
      />
      <Grid item xs={12} style={{ textAlign: "left", marginTop: "15px" }}>
        {props.isExpired && (
          <Button
            id="btnUpdateCard"
            variant={
              !companyInfo?.isCreditCardEnabled ? "contained" : "outlined"
            }
            disabled={!companyInfo?.isCreditCardEnabled}
            sx={{
              textTransform: "none",
              marginRight: "0.5rem",
              borderColor: companyInfo?.isCreditCardEnabled ? "black" : undefined,
              color: companyInfo?.isCreditCardEnabled ? "black" : undefined,
            }}
            onClick={props.updateCard}
          >
            {t("carClasses.labelBtnUpdate")}
          </Button>
        )}
        <Button
          id="btnDeleteCard"
          color="error"
          variant="outlined"
          aria-label={t("lblContinueToNextStep")}
          onClick={props.deleteCard}
        >
          {t("carClasses.labelBtnRemove")}
        </Button>{" "}
      </Grid>
    </Box>
  );
};
export default SavedCardResult;
